import client from '@/api/client';
import { BASE_URL } from '@/constants';

export default {
	fetchProcesses: ({ plantCd, urlSearchParams }) => {
		return client
			.get(`${BASE_URL}/sync/v1/plants/${plantCd}/processes?${urlSearchParams}`)
			.then(response => (response && response.data) || null)
			.catch(error => {
				throw error;
			});
	},

	fetchPlants: () => {
		return client
			.get(`${BASE_URL}/cc/v1/plant`)
			.then(response => (response && response.data) || null)
			.catch(error => {
				throw error;
			});
	},

	getCommonCdList: ({ plantCd, commCdType }) => {
		return client
			.post(`${BASE_URL}/cc/v1/plants/${plantCd}/commonCodes?commCdType=${commCdType}`)
			.then(response => (response && response.data) || null)
			.catch(error => {
				throw error;
			});
	},

	fetchPgmIds: ({ plantCd }) => {
		return client
			.get(`${BASE_URL}/cc/v1/plants/${plantCd}/programs`)
			.then(response => (response && response.data) || null)
			.catch(error => {
				throw error;
			});
	},

	fetchSqlDetails: ({ plantCd, procId }) => {
		return client
			.get(`${BASE_URL}/sync/v1/plants/${plantCd}/processes/${procId}/sqlDetails`)
			.then(response => (response && response.data) || null)
			.catch(error => {
				throw error;
			});
	},

	saveSqlDetails: ({ plantCd, procId, sqlDetails }) => {
		return client
			.post(`${BASE_URL}/sync/v1/status/1/plants/${plantCd}/processes/${procId}/sqlDetails`, sqlDetails)
			.then(response => (response && response.data) || null)
			.catch(error => {
				throw error;
			});
	}
};
